export const SMARTSHEET_TYPES = {
  general: 'general',
  residential: 'residential',
  industrial_commercial: 'industrial_commercial',
  pmgd: 'pmgd'  
}